export default {
  borderColorDisabled: 'none',
  backgroundDisabled: 'var(--light-grey)',
  backgroundEnabled: 'var(--mpc)',
  backgroundEnabledValidatedEmail: 'var(--cta-color)',
};
